import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { defineCustomElements } from '@ionic/pwa-elements/loader';

if (environment.production) {
  enableProdMode();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch(err => console.log(err));

// Some Capacitor plugins, such as Camera or Toast, have web-based UI available when not running natively.
// To enable these controls, use 'ionic/pwa-elements' and call the element loader after the platform has been bootstrapped
defineCustomElements(window);
